import { dataFetcher } from 'core/services/requestHandler';   

const getAdminList = async (data = {}, config = {}) => {
  return dataFetcher('users/getAdminList', data, {...config});
};

const activateAdmin = async (data = {}, config = {}) => {
  return dataFetcher('users/activateAdmin', data, {...config});
};

const deactivateAdmin = async (data = {}, config = {}) => {
  return dataFetcher('users/deactivateAdmin', data, {...config});
};

const updateAdmin = async (data = {}, config = {}) => {
  return dataFetcher('users/updateAdmin', data, {method: 'POST', ...config});
};

const addAdmin = async (data = {}, config = {}) => {
  return dataFetcher('users/addAdmin', data, {method: 'POST', ...config});
};

const getAdminRoles = async (data = {}, config = {}) => {
  return dataFetcher('users/roles', data, {...config});
};

export { getAdminList, activateAdmin, deactivateAdmin, addAdmin, updateAdmin, getAdminRoles };
